import { render } from "./ButtonHeader.vue?vue&type=template&id=2f63bde4&scoped=true"
import script from "./ButtonHeader.vue?vue&type=script&lang=js"
export * from "./ButtonHeader.vue?vue&type=script&lang=js"

import "./ButtonHeader.vue?vue&type=style&index=0&id=2f63bde4&scoped=true&lang=css"

import exportComponent from "/tmp/builds/1syD-sny/0/plataforma/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f63bde4"]])

export default __exports__